module.exports = __webpack_public_path__ + "static/computer-2fb0cf2e79c2146bdd50aa4116fa2acd.jpg";